import React from "react";
import { useField, useFormikContext } from "formik";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment-timezone";
import 'bootstrap-daterangepicker/daterangepicker.css';

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function DateRangPickerFieldwithouttoday({ ...props }) {
  const { setFieldValue, errors, touched } = useFormikContext();
  const [field] = useField(props);

  const UpdateValue = (start, end, label) => {
    console.log(start, end, label);
    const rang = {
      from: start,
      to: end
    };
    if (props?.Updatedrang) {
      props.Updatedrang(rang);
    }

    setFieldValue(field.name, rang);
  };

  var dt = new Date();
  dt.setMonth(dt.getMonth() + 2);

  const initialStartDate = moment(new Date()).subtract(1, 'days');
  const initialEndDate = moment(new Date()).subtract(1, 'days');

  return (
    <>
      {props.label && <label className={props.isRequired ? 'required' : ''}>{props.label}</label>}
      <DateRangePicker
        initialSettings={{
          startDate: props.dateRang?.from || initialStartDate,
          endDate: props.dateRang?.to || initialEndDate,
          ranges: {
            'Yesterday': [initialStartDate, initialEndDate],
            'Last 7 Days': [moment(new Date()).subtract(6, 'days'), moment(new Date())],
            'Last 30 Days': [moment(new Date()).subtract(29, 'days'), moment(new Date())],
            'This Month': [moment(new Date()).startOf('month'), moment(new Date()).endOf('month')],
            'Last Month': [moment(new Date()).subtract(1, 'month').startOf('month'), moment(new Date()).subtract(1, 'month').endOf('month')],
            "All Time": [moment("01-01-2000", "DD-MM-YYYY"), moment(new Date(dt))],
          },
        }}
        onCallback={UpdateValue}>
        <input type="text" name="daterange" className="form-control" placeholder="Select Date" />
      </DateRangePicker>
      {errors[field.name] && touched[field.name] ? (
        <div className="invalid-datepicker-feedback">
          {errors[field.name].toString()}
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
}
